import { render, staticRenderFns } from "./stationTag.vue?vue&type=template&id=49c9e087&scoped=true"
import script from "./stationTag.vue?vue&type=script&lang=js"
export * from "./stationTag.vue?vue&type=script&lang=js"
import style0 from "./stationTag.vue?vue&type=style&index=0&id=49c9e087&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c9e087",
  null
  
)

export default component.exports